import { PaginationResponse } from "models/pagination-response";
import { IEmendaParlamentarPagedRequest } from "models/request/emenda-parlamentar-paged-request";
import { IEmendaParlamentarPagedResponse } from "models/response/emenda-parlamentar-paged-response";
import { ITipoEmendaResponse } from "models/response/tipo-emenda-response";
import { IFormaRepasseEmendaResponse } from "models/response/forma-repasse-emenda-response";
import { IEmendaParlamentarTotaisResponse } from "models/response/emenda-parlamentar-totais-response";

export type EmendasParlamentaresState = {
    emendas: PaginationResponse<IEmendaParlamentarPagedResponse>;
    emendaPagedRequest: IEmendaParlamentarPagedRequest;
    tipos: ITipoEmendaResponse[];
    formasRepasse: IFormaRepasseEmendaResponse[];
    ultimaAtualizacao: string | null;
    totais: IEmendaParlamentarTotaisResponse;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setEmendas = 'setEmendas',
    setEmendaPagedRequest = 'setEmendaPagedRequest',
    setTipos = 'setTipos',
    setFormasRepasse = 'setFormasRepasse',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setTotais = 'setTotais',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const EmendasParlamentaresReducer = (state: EmendasParlamentaresState, action: any): EmendasParlamentaresState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setEmendaPagedRequest:
            return { ...state, emendaPagedRequest: payload };
        case ACTION_TYPES.setEmendas:
            return { ...state, emendas: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setFormasRepasse:
            return { ...state, formasRepasse: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setTotais:
            return { ...state, totais: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
